function mergeObjectValues(obj1: Record<string, string>, obj2: Record<string, string>) {
  const mergedObj: Record<string, string> = {}

  for (const key in obj1) {
    mergedObj[key] = Object.hasOwn(obj2, key) ? obj2[key] : obj1[key]
  }

  return mergedObj
}
export default mergeObjectValues
